import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import ChipSelect from '../common/ChipSelect';
import ChipSelectMultiple from '../common/ChipSelectMultiple';
import Divider from '../styles/HorizontalDivider';
import FabricInfo from './FabricInfo';

const SizeSelectionLegend = (
    <FormattedMessage
        id='SIZE_SELECTION_LEGEND'
        description='Label of the size selection form element.'
        defaultMessage='Größe & Stoff wählen'
    />
);

const SewpatSizeAndOptionSelectLabel = (
    <FormattedMessage
        id='SEWPAT_SIZE_OPTION_SELECT_LABEL'
        description='Label for sewpat options select form.'
        defaultMessage='Größe, Variante & Stoff wählen'
    />
);


/**
 * Fabric selection component.
 */
const SizeSelection = ({
    sizes, multisize, activeSize, handleSizeChange,
    handleOptionsChange, wrapper, helpText,
    size, withOptions, options, activeOptions, handleProductChange,
    activeProductId, products, disableSizeSelection, fabrics,
    activeFabricId, handleFabricChange,
}) => {
    const onSizeChange = size => handleSizeChange(size);
    const onOptionChange = options => handleOptionsChange(options);
    const onProductChange = productId => handleProductChange(productId);
    const onFabricChange = value => handleFabricChange(value);

    const Label = withOptions
        ? SewpatSizeAndOptionSelectLabel
        : SizeSelectionLegend;

    const buildSizes = () => {
        const Sizes = sizes.map(size => (
            {
                value: size,
                label: size,
            }
        ));
        return Sizes;
    };

    const buildFabrics = () => {
        const Fabrics = Object.keys(fabrics).map(fabricId => (
            {
                value: fabricId,
                label: fabrics[fabricId].title,
            }
        ));
        return Fabrics;
    };

    const buildProductOptions = () => {
        const Products = Object.keys(products).map(productId => (
            {
                value: products[productId].id,
                label: products[productId].title,
            }
        ));
        return Products;
    };

    const buildOptions = () => {
        const Options = Object.keys(options).map(id => (
            {
                value: id,
                label: options[id].label,
            }
        ));
        return Options;
    };

    const Wrapper = styled(wrapper)`
         & .schnoffle-chip-default {
           margin: 0.5em 1em 0.5em 0;
           transition: background-color 0.5s ease, color 0.5s ease;
           &:hover {
             background-color: ${props => props.theme.palette.secondary.light};
           }
           &:focus {
             background-color: ${props => props.theme.palette.secondary.main};
             color: white;
           }
         }
        & .schnoffle-chip-selected {
          transition: background-color 0.5s ease, color 0.5s ease;
          color: white;
          background-color: ${props => props.theme.palette.secondary.main};
        }
        & .schnoffle-chip-default.schnoffle-chip-disabled {
           margin: 0.5em 1em 0.5em 0;
           transition: background-color 0.5s ease, color 0.5s ease;
           color: #AAA;
           &:hover {
             background-color: #DDD;
             cursor: not-allowed;
           }
           &:focus {
             background-color: #DDD;
             cursor: not-allowed;
           }
         }
         & .schnoffle-flex {
            display: flex;
            flex-wrap: nowrap;
         }
    `;

    return (
        <Wrapper className='stolo-cart-item'>
            <legend>
                {Label}
            </legend>
            <ChipSelect
                handleChange={onProductChange}
                defaultChipID={activeProductId}
                data={buildProductOptions()}
            />
            <Divider key='divider-1' margin='0.5em 0 0.5em' />
            <ChipSelect
                handleChange={onSizeChange}
                data={buildSizes()}
                defaultChipID={size}
                disabled={!!disableSizeSelection}
            />
            {withOptions ?
            [
                <Divider key='divider-2' margin='0.5em 0 0.5em' />,
                <ChipSelectMultiple
                    handleChange={onOptionChange}
                    data={buildOptions()}
                    activeChips={activeOptions}
                    key='OptionsSelect'
                    disabled={!!disableSizeSelection}
                />,
            ]
                : null
            }
            <Divider key='divider-3' margin='0.5em 0 0.5em' />
            <ChipSelect
                handleChange={onFabricChange}
                defaultChipID={activeFabricId}
                data={buildFabrics()}
                disabled={!!disableSizeSelection}
            />
            <FabricInfo fabricInfo={fabrics[activeFabricId]} />
        </Wrapper>
    );
};

export default SizeSelection;



// WEBPACK FOOTER //
// ./src/components/addtocart/SizeSelection.js